<template>
	<div class="pointer plr-10 co-F52F3E">
		<!-- 删除按钮 -->
		<div @click="Operate">{{translate.ShowText('删除')}}</div>
	</div>
</template>

<script lang="ts" setup>
	import translate from '@/api/translate';
	const emits = defineEmits(["change"]);
	
	const Operate = () => {
		emits("change");
	}
</script>

<style lang="scss" scoped>
</style>